<template>
  <div
    v-if="loaded"
    class="page incidents-module"
  >
    <div class="page__sidebar">
      <incidents-side-bar
        :counters="myIncidentCounts"
        @click-add-filter="onClickAddFilter"
        @update-option="onClickUpdateFilter"
      />
    </div>
    <div class="page__main">
      <router-view
        :key="$route.path"
        ref="mainContent"
        class="page__main-content"
        @incident-added="loadSidebarIncidentCounts"
        @incident-closed="loadSidebarIncidentCounts"
      />
    </div>
  </div>
</template>

<script>
import IncidentsSideBar from './sideBar/IncidentsSideBar'
import sideBarStore from './sideBar/incidentSideBarStore'
import incidentServices from '@/api/resources/incident/incidentServices'
import incidentSeverityServices from '@/api/resources/incident/incidentSeverityServices'
import { INCIDENT_TASK } from '@/modules/incidentsModule/sideBar/sideBarOptions'
import { GridUtils } from '@/shared/util/grid-utils'

export default {
    name: 'IncidentsIndex',
    components: {
        IncidentsSideBar
    },
    data() {
        return {
            loaded: false,
            sideBarState: sideBarStore.state,
            sidebarSummaryInterval: null,
            myIncidentCounts: null
        }
    },
    computed: {
        routeName() {
            return this.$route.name
        },
        laboratoryId() {
            return this.$store.getters.labId
        }
    },
    watch: {
        routeName() {
            this.checkRoute()
        }
    },
    async created() {
        try {
            const [err, severities] = await this.toCall(incidentSeverityServices.getSeverities(this.laboratoryId))
            if (err) {
                this.showErrorModalGlobal()
                return
            }
            const severityOptions = this.mapSeveritiesToSideBarOptions(severities)
            this.updateSideBarOptionChildren(sideBarStore.state.options.expanded, 'severities', severityOptions)

            await Promise.all([
                this.loadSidebarIncidentCounts(),
                sideBarStore.loadCustomOptions(),
                sideBarStore.loadConfig()
            ])

            if (this.sideBarState.config.defaultOptionId) {
                sideBarStore.selectDefaultOption()
            }

            this.sidebarSummaryInterval = this.$_setSummaryInterval(this.loadSidebarIncidentCounts)
        } catch (e) {
            this.showErrorModalGlobal()
        } finally {
            this.loaded = true
        }
    },
    beforeDestroy() {
        if (this.sidebarSummaryInterval !== null) {
            clearInterval(this.sidebarSummaryInterval)
        }
        sideBarStore.setSelectedOption(null)
        this.cleanSearchStateGlobalMixin()
    },
    methods: {
        onIncidentAdded() {
            this.onIncidentAddedOrClosed()
        },
        onIncidentClosed() {
            this.onIncidentAddedOrClosed()
        },
        onIncidentAddedOrClosed() {
            this.loadSidebarIncidentCounts()
            if (this.$refs.mainContent.reloadRowData) {
                this.$refs.mainContent.reloadRowData()
            }
        },
        async loadSidebarIncidentCounts() {
            this.myIncidentCounts = await incidentServices.myIncidentSummary()
        },
        onClickAddFilter() {
            if (this.$refs.mainContent.onSideBarClickAddFilter) {
                this.$refs.mainContent.onSideBarClickAddFilter()
            }
        },
        onClickUpdateFilter(option) {
            if (this.$refs.mainContent.onSideBarClickUpdateFilter) {
                this.$refs.mainContent.onSideBarClickUpdateFilter(option)
            }
        },
        mapSeveritiesToSideBarOptions(severities) {
            return severities.map(severity => {
                return {
                    id: severity.id,
                    label: severity.name,
                    uicomponent: 'uicomponent.incidents.filter.relatedToMe',
                    task: INCIDENT_TASK.RELATED_TO_ME,
                    filterModel: {
                        'incidentSeverity.id': GridUtils.getSetFilterModel([severity.id.toString()])
                    }
                }
            })
        }
    }
}

</script>
